export class ForumConstants {
  /**
   * Maximum length of a forum topic title
   */
  public static readonly MAX_TOPIC_TITLE_LENGTH = 255;

  /**
   * Default maximum words for generated title
   */
  public static readonly DEFAULT_TITLE_MAX_WORDS = 12;

  /**
   * Default maximum number of tags for tag generation
   */
  public static readonly DEFAULT_MAX_TAGS = 10;
}
